const initialState = {
    escapeBuckAmount: 0,
    escapeBuckCodeRedeemModal: false,
    isApiCallForFetchingEscapeBuckAmount: true,
    isApiCallForFetchingEscapeRedeemHistory: false,
}
const escapeBucksReducers = (state = initialState, action) => {
    switch (action.type) {
        case "ESCAPEBUCKAMOUNT":
            return {
                ...state,
                escapeBuckAmount: action.payload
            };
        case "ESCAPEBUCKCODEREDEEMMODAL":
            return {
                ...state,
                escapeBuckCodeRedeemModal: action.payload
            };
        case "ESCAPEBUCKAPICALLFETCHING":
            return {
                ...state,
                isApiCallForFetchingEscapeBuckAmount: action.payload
            };
        case "ESCAPEBUCKAPICALLFETCHINGFORREDEEMHISTORY":
            return {
                ...state,
                isApiCallForFetchingEscapeRedeemHistory: action.payload
            };

        default:
            return { ...state };

    }
}
export default escapeBucksReducers